import { useState, useEffect, useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import { Chart } from "react-google-charts";
import InfiniteScroll from "react-infinite-scroller";
import DOMPurify from "dompurify";
import iconsEdit from "../../assets/svg/icons-edit.svg";
import iconsAddToList from "../../assets/svg/icons-addToList.svg";
import iconsDelete from "../../assets/svg/icons-delete.svg";
import iconsExternalLink from "../../assets/svg/icons-externalLink.svg";
import { getColorByCategory } from "../../helpers/heplers";
import { makeImageSrcByName } from "../../utils/makeImageSrcByName";

import PropTypes from "prop-types";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import iconsSortUp from "../../assets/svg/icons-sortUp.svg";

import { Dropdown } from "react-bootstrap";

import { filterMessagesRestarted } from "../../actions/filterActions";

import {
  GET_DOCUMENT_BY_ID_AWAITING_ID,
  EARTH_ICON,
  IMAGE_BASE,
} from "../../constants/stringConstants";
import { topicsPerBusinessUnits } from "../../constants/topicsPerBusinessUnits";

import AlertMessage from "../../utils/AlertMessage";
import CustomModal from "../../utils/CustomModal";
import { formatDate } from "../../utils/formatDate";
import Loader from "../../utils/Loader";
import { processGraphCellValue } from "../../utils/processGraphCellValue";

import StarBookmark from "../OverviewComponents/StarBookmark";
import {
  addDocument,
  addLink,
  getTilesOfTypeLinks,
} from "../../actions/tileActions";
import FieldsInForm from "../../utils/FieldsInForm";

const SearchOverviewSmallScreen = ({
  userRights,
  filterFailureMessage,
  filterSuccessMessage,
  filterMessagesRestarted,
  filtersAreLoading,
  filtersTypesAreLoading,
  regulatoryStreamAreLoading,
  top5PublishersAreLoading,
  graphAggregationsAreLoading,
  graphAggregationsTotalAmount,
  top5Publishers,
  top5Countries,
  regulatoryStream,
  setEditNewsModal,
  setSortField,
  graphAggregationsDetailsFormatted,
  hotTopics,
  hotBusinessUnits,
  regulatoryStreamPaginationError,
  handlePagination,
  regulatoryStreamLoadedWithError,
  showDeleteNewsModal,
  setAddNewsModal,
  tilesOfTypeLinks,
  addLink,
  singleTopic,
  userToken,
}) => {
  const { t } = useTranslation(),
    [failureMessage, setFailureMessage] = useState(""),
    [successMessage, setSuccessMessage] = useState(""),
    history = useHistory();

  const [showGraph, setShowGraph] = useState(false);
  const [showTop5Publishers, setShowTop5Publishers] = useState(false);
  const [showTop5Countries, setShowTop5Countries] = useState(false);
  const [itemVisibility, setItemVisibility] = useState({});

  const [addToListDialogIsShown, setAddToListDialogIsShown] = useState(false);
  const [tile, setTile] = useState(
    tilesOfTypeLinks.length > 0 ? tilesOfTypeLinks[0] : 0
  );
  const [submitOccurred, setSubmitOccurred] = useState(false);

  const argsForAddListDialog = {
    findFormErrors: () => {
      const newErrors = {};

      if (!tile.TILE_ID)
        newErrors.TILE_ID = t("optionMustBeSelectedFromDropdown");

      return newErrors;
    },
    fields: [
      {
        name: "TILE_ID",
        type: "select",
        options: tilesOfTypeLinks,
        required: true,
        displayProperty: "TILE_NAME",
        valueProperty: "TILE_ID",
        label: t("selectList"),
        value: tile.TILE_ID,
      },
    ],
    classNameReactFormal: "register-login-react-formal",
    classNameForm: "register-login-react-form",
    onSelectBoxChanged: (TILE_ID) => {
      setTile(tilesOfTypeLinks.find((t) => t.id === TILE_ID));
    },
    onSubmit: () => {
      addLink(
        userToken,
        tile.TILE_ID,
        tile.TILE_NAME,
        window.location.href,
        "",
        history.location.state?.from === "search"
          ? undefined
          : singleTopic.TOPIC_ID,
        true
      );
      setTile(tilesOfTypeLinks[0]);
      setAddToListDialogIsShown(false);
    },
  };

  const toggleVisibility = (id) => {
    setItemVisibility((prevVisibility) => ({
      ...prevVisibility,
      [id]: !prevVisibility[id],
    }));
  };

  const sanitizer = DOMPurify.sanitize;

  useEffect(() => {
    if (filterFailureMessage) {
      setFailureMessage(filterFailureMessage);
    }

    if (filterSuccessMessage) {
      setSuccessMessage(filterSuccessMessage);
    }
  }, [
    filterFailureMessage,
    filterSuccessMessage,
    setFailureMessage,
    setSuccessMessage,
  ]);
  const [sortBy, setSortBy] = useState({ sort: "relevance", reverse: false });

  const revelanceSort = () => {
    setSortField("");
    setSortBy((prev) => ({
      sort: "relevance",
      reverse: prev.sort === "relevance" ? !prev.reverse : false,
    }));
  };

  const newsDateSort = () => {
    setSortField("news_date");
    setSortBy((prev) => ({
      sort: "publicationDate",
      reverse: prev.sort === "publicationDate" ? !prev.reverse : false,
    }));
  };

  const newsTypeSort = () => {
    setSortField("news_type");
    setSortBy((prev) => ({
      sort: "publicationType",
      reverse: prev.sort === "publicationType" ? !prev.reverse : false,
    }));
  };

  const summarizedTopicsPerUnits = useMemo(() => {
    let totalValue = 0;

    Object.entries(hotTopics).map(([, topic]) => {
      Object.entries(hotBusinessUnits).map(([, unit]) => {
        if (topic && unit) totalValue += topic * unit;
      });
    });

    return totalValue || 1;
  }, [hotBusinessUnits, hotTopics]);

  const handleImgError = useCallback((e) => {
    e.target.onerror = null;
    e.target.src = `${IMAGE_BASE}topic.jpg`;
  }, []);

  return (
    <>
      <Container className="overview-small-screen-container" expand="lg">
        <Row className="overview-filter-row">
          <Col>
            <Card
              className={
                showGraph
                  ? "overview-second-col-first-row-first-col-first-card no-border overview-responsive-card aggregation-graph-responsive"
                  : "overview-second-col-first-row-first-col-first-card no-border overview-responsive-card height-auto"
              }
            >
              <Card.Body>
                <span
                  className="first-card-first-col-title fs-16 cursor-pointer"
                  onClick={() => {
                    if (!showGraph) setShowGraph(true);
                    else setShowGraph(false);
                  }}
                >
                  {t("publications")}
                  <img
                    width={24}
                    height={24}
                    className={
                      !showGraph
                        ? "arrow-icon arrow-icon-down cursor-pointer"
                        : "display-none"
                    }
                    src={iconsSortUp}
                    onClick={() => setShowGraph(true)}
                  />
                  <img
                    width={24}
                    height={24}
                    className={
                      !showGraph
                        ? "display-none"
                        : "arrow-icon arrow-icon-up cursor-pointer"
                    }
                    onClick={() => setShowGraph(false)}
                    src={iconsSortUp}
                  />
                </span>
                <span
                  className={
                    showGraph ? "first-card-first-col-total" : "display-none"
                  }
                >
                  <span className="first-card-first-col-footer-total fs-12">
                    {t("total")}
                  </span>
                  <span className="first-card-first-col-footer-total-value fs-30">
                    {graphAggregationsTotalAmount}
                  </span>
                  {graphAggregationsDetailsFormatted && (
                    <Chart
                      chartType="LineChart"
                      data={
                        graphAggregationsDetailsFormatted.length &&
                        graphAggregationsDetailsFormatted
                      }
                      className={"line-chart-graph-aggregation"}
                      height={350}
                      options={{
                        series: {
                          0: { color: "#00C853" },
                        },
                        legend: {
                          position: "bottom",
                        },
                      }}
                    />
                  )}
                </span>
              </Card.Body>
            </Card>

            <Card
              className={
                showTop5Publishers
                  ? "overview-second-col-first-row-first-col-second-card no-border overview-responsive-card top5-publishers-responsive-card"
                  : "overview-second-col-first-row-first-col-second-card no-border overview-responsive-card top5-publishers-responsive-card height-auto"
              }
            >
              <Card.Body>
                <span
                  className="first-card-first-col-title fs-16 cursor-pointer"
                  onClick={() => {
                    if (!showTop5Publishers) setShowTop5Publishers(true);
                    else setShowTop5Publishers(false);
                  }}
                >
                  {t("top5Publishers")}
                  <img
                    width={24}
                    height={24}
                    className={
                      !showTop5Publishers
                        ? "arrow-icon arrow-icon-down cursor-pointer"
                        : "display-none"
                    }
                    src={iconsSortUp}
                    onClick={() => setShowTop5Publishers(true)}
                  />
                  <img
                    width={24}
                    height={24}
                    className={
                      !showTop5Publishers
                        ? "display-none"
                        : "arrow-icon arrow-icon-up cursor-pointer"
                    }
                    onClick={() => setShowTop5Publishers(false)}
                    src={iconsSortUp}
                  />
                </span>
                <span
                  className={
                    showTop5Publishers
                      ? "first-card-first-col-footer"
                      : "display-none"
                  }
                >
                  {Object.keys(top5Publishers).map((publisher, index) => {
                    return (
                      <span
                        key={publisher + index}
                        className="top-5-publisher no-border"
                      >
                        <span className="top-5-publisher-name fs-12">
                          {publisher}
                        </span>
                        <span className="top-5-publisher-value fs-30">
                          {top5Publishers[publisher]}
                        </span>
                      </span>
                    );
                  })}
                </span>
              </Card.Body>
            </Card>

            <Card
              className={
                showTop5Countries
                  ? "overview-second-col-first-row-first-col-second-card no-border overview-responsive-card top5-publishers-responsive-card"
                  : "overview-second-col-first-row-first-col-second-card no-border overview-responsive-card top5-publishers-responsive-card height-auto"
              }
            >
              <Card.Body>
                <span
                  className="first-card-first-col-title fs-16 cursor-pointer"
                  onClick={() => {
                    if (!showTop5Countries) setShowTop5Countries(true);
                    else setShowTop5Countries(false);
                  }}
                >
                  {t("top5Countries")}

                  <img
                    width={24}
                    height={24}
                    className={
                      !showTop5Countries
                        ? "arrow-icon arrow-icon-down cursor-pointer"
                        : "display-none"
                    }
                    src={iconsSortUp}
                    onClick={() => setShowTop5Countries(true)}
                  />
                  <img
                    width={24}
                    height={24}
                    className={
                      !showTop5Countries
                        ? "display-none"
                        : "arrow-icon arrow-icon-up cursor-pointer"
                    }
                    onClick={() => setShowTop5Countries(false)}
                    src={iconsSortUp}
                  />
                </span>
                <span
                  className={
                    showTop5Countries
                      ? "first-card-first-col-footer third-card-second-col-top-counties"
                      : "display-none"
                  }
                >
                  {Object.entries(top5Countries)
                    .sort((a, b) => b[1] - a[1])
                    .map(([country, value]) => {
                      return (
                        <p
                          className="info-with-icon-and-text fs-14"
                          key={country + value}
                        >
                          <img
                            width={16}
                            height={16}
                            src={EARTH_ICON}
                            className="left-options-icon"
                          />
                          {country}: {value}
                        </p>
                      );
                    })}
                </span>
              </Card.Body>
            </Card>

            <Card className="overview-second-col-first-row-first-col-fourth-card no-border">
              <Card.Body>
                <div className="overview-fourth-card-left">
                  <span className="first-card-first-col-title fs-16">
                    {t("hotTopics")}
                  </span>
                  <div className="overview-fourth-card-left-topics">
                    {Object.entries(hotTopics).map(([topic, value]) => (
                      <p
                        className="info-with-icon-and-text fs-12"
                        key={topic + value}
                      >
                        <img
                          width={14}
                          height={14}
                          src={makeImageSrcByName(topic)}
                          onError={handleImgError}
                          className="left-options-icon"
                        />
                        {topic}
                      </p>
                    ))}
                  </div>
                  <span className="first-card-first-col-title fs-16">
                    {t("hotBusinessUnits")}
                  </span>
                  <div className="overview-fourth-card-left-topics">
                    {Object.entries(hotBusinessUnits).map(([topic, value]) => (
                      <p
                        className="info-with-icon-and-text fs-12"
                        key={topic + value}
                      >
                        <img
                          width={14}
                          height={14}
                          src={makeImageSrcByName(topic)}
                          onError={handleImgError}
                          className="left-options-icon"
                        />
                        {topic}
                      </p>
                    ))}
                  </div>
                </div>
                <div className="overview-fourth-card-right">
                  <span className="first-card-first-col-title overview-fourth-card-right-title fs-16">
                    {t("hotTopicsPerBusinessUnit")}
                  </span>
                  <div className="overview-fourth-card-right-graph">
                    <div className="overview-fourth-card-right-graph-row-text">
                      {topicsPerBusinessUnits.topics.map((topic) => (
                        <div
                          className="graph-row-text-vertical fs-12"
                          key={topic}
                        >
                          <div>{topic}</div>
                        </div>
                      ))}
                    </div>
                    {topicsPerBusinessUnits.units.map((unit) => {
                      return (
                        <div
                          className="overview-fourth-card-right-graph-row"
                          key={unit}
                        >
                          <div className="graph-row-text-horizontal fs-12">
                            {unit}
                          </div>
                          {topicsPerBusinessUnits.topics.map((topic) => {
                            const cellColor = processGraphCellValue(
                              hotTopics[topic],
                              hotBusinessUnits[unit],
                              summarizedTopicsPerUnits
                            );

                            return (
                              <div
                                key={topic}
                                className={`overview-fourth-card-right-graph-col graph-${cellColor}`}
                              />
                            );
                          })}
                        </div>
                      );
                    })}
                    <div className="overview-fourth-card-right-graph-footer">
                      <div className="overview-fourth-card-right-graph-footer-col graph-hot" />
                      <p className="overview-fourth-card-right-graph-footer-text fs-10">
                        Hot
                      </p>
                      <div className="overview-fourth-card-right-graph-footer-col graph-warm" />
                      <p className="overview-fourth-card-right-graph-footer-text fs-10">
                        Warm
                      </p>
                      <div className="overview-fourth-card-right-graph-footer-col graph-tepid" />
                      <p className="overview-fourth-card-right-graph-footer-text fs-10">
                        Tepid
                      </p>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Col className="overview-second-col-first-row-second-col">
              <div className="overview-second-col-first-row-second-col-header">
                <span className="first-card-first-col-title fs-16">
                  {t("newslist")}
                </span>
                <button
                  className="overview-second-col-card-btn overview-second-col-first-row-btn"
                  type="button"
                  onClick={() => setAddNewsModal(true)}
                  disabled={
                    !(
                      userRights.USER_RIGHT?.toLowerCase().includes(
                        "read_write_delete_new"
                      ) ||
                      userRights.USER_RIGHT?.toLowerCase().includes("partner")
                    )
                  }
                >
                  <img
                    width={32}
                    height={32}
                    src={iconsAddToList}
                    className="left-options-icon"
                  />
                  <p className="overview-second-col-card-btn-text fs-16">
                    {t("addANews")}
                  </p>
                </button>
                <Dropdown
                  variant="secondary"
                  autoclose="false"
                  className="overview-second-col-first-row-second-col-sort"
                >
                  <Dropdown.Toggle className="overview-second-col-first-row-second-col-sort-btn fs-16">
                    {t(sortBy.sort)}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onSelect={() => revelanceSort()}>
                      {t("relevance")}
                    </Dropdown.Item>
                    <Dropdown.Item onSelect={() => newsDateSort()}>
                      {t("publicationDate")}
                    </Dropdown.Item>
                    <Dropdown.Item onSelect={() => newsTypeSort()}>
                      {t("publicationType")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="overview-second-col-first-row-second-col-body">
                <InfiniteScroll
                  loadMore={() => {
                    if (
                      !regulatoryStreamLoadedWithError &&
                      !regulatoryStreamPaginationError &&
                      !regulatoryStreamAreLoading &&
                      regulatoryStream?.length
                    )
                      handlePagination();
                  }}
                  hasMore={true}
                  useWindow={false}
                >
                  {regulatoryStream?.map(
                    (
                      {
                        id,
                        bookmark,
                        news_link,
                        news_summary,
                        news_date,
                        news_topic,
                        news_type,
                        news_title,
                        source_name,
                        news_label,
                      },
                      index
                    ) => (
                      <Card
                        className="overview-second-col-first-row-second-col-card no-border"
                        key={id + index}
                      >
                        <Card.Header className="overview-second-col-card-header no-border">
                          <div className="overview-second-col-card-header-star">
                            <StarBookmark value={bookmark} />
                          </div>
                          {/* <a
                            className="overview-second-col-card-title fs-20"
                            href={news_link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {news_title}
                          </a> */}
                          <div>
                            <a
                              className="overview-second-col-card-title"
                              href={news_link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {news_title}
                            </a>
                            <br />
                            <span
                              className={`${
                                // !itemVisibility[id]
                                //   ? "card-hidden"
                                //   :
                                "span-date-source"
                              }`}
                            >
                              {news_date
                                ? formatDate(new Date(news_date), "dd.mm.yyyy")
                                : ""}{" "}
                              | {source_name || "-"}{" "}
                              <p
                                style={{
                                  background: `${getColorByCategory(
                                    news_type
                                  )}`,
                                }}
                                className="overview-second-col-card-text overview-second-col-card-type fs-12"
                              >
                                {news_type || "-"}
                              </p>
                            </span>
                          </div>
                          <div className="overview-second-col-card-btns-res">
                            <button
                              className="overview-second-col-card-btn"
                              type="button"
                              disabled={
                                !(
                                  userRights.USER_RIGHT?.toLowerCase().includes(
                                    "read_write_delete_new"
                                  ) ||
                                  userRights.USER_RIGHT?.toLowerCase().includes(
                                    "partner"
                                  )
                                )
                              }
                              onClick={() => setEditNewsModal(id)}
                            >
                              <img
                                width={24}
                                height={24}
                                src={iconsEdit}
                                className="left-options-icon"
                              />
                              <p className="overview-second-col-card-btn-text fs-14">
                                {t("edit")}
                              </p>
                            </button>
                            <button
                              className="overview-second-col-card-btn"
                              type="button"
                              onClick={() => showDeleteNewsModal(id)}
                              disabled={
                                !(
                                  userRights.USER_RIGHT?.toLowerCase().includes(
                                    "read_write_delete"
                                  ) ||
                                  userRights.USER_RIGHT?.toLowerCase().includes(
                                    "read_write_delete_new"
                                  ) ||
                                  userRights.USER_RIGHT?.toLowerCase().includes(
                                    "partner"
                                  )
                                )
                              }
                            >
                              <img
                                width={24}
                                height={24}
                                src={iconsDelete}
                                className="left-options-icon"
                              />
                              <p className="overview-second-col-card-btn-text fs-14">
                                {t("delete")}
                              </p>
                            </button>
                            <button
                              className="overview-second-col-card-btn"
                              type="button"
                              onClick={() => {
                                history.push(
                                  GET_DOCUMENT_BY_ID_AWAITING_ID + id,
                                  {
                                    from: "topic",
                                  }
                                );
                              }}
                            >
                              <img
                                width={24}
                                height={24}
                                src={iconsExternalLink}
                                className="left-options-icon"
                              />
                              <p className="overview-second-col-card-btn-text fs-14">
                                {t("assess")}
                              </p>
                            </button>
                          </div>
                        </Card.Header>
                        {news_summary.length > 1 && (
                          <div className="container-btn-show-more-less">
                            <button
                              className="btn-show-more-less"
                              onClick={() => toggleVisibility(id)}
                            >
                              {itemVisibility[id] ? "Collapse" : "Show More"}
                            </button>
                          </div>
                        )}
                        <div
                          className={`${
                            !itemVisibility[id] ? "card-hidden" : ""
                          }`}
                        >
                          <Card.Body className="overview-second-col-card-body">
                            <p className="overview-second-col-card-subtitle  fs-14">
                              {t("summary")}
                            </p>
                            <p
                              className="overview-second-col-card-text summary fs-14"
                              dangerouslySetInnerHTML={{
                                __html: sanitizer(
                                  itemVisibility[id]
                                    ? news_summary
                                    : news_summary.slice(0, 900)
                                ),
                              }}
                            />
                          </Card.Body>
                          <Card.Footer className="overview-second-col-card-footer">
                            <Row>
                              <Col>
                                <p className="overview-second-col-card-subtitle fs-14">
                                  {t("topics")}
                                </p>
                                {news_topic
                                  ?.filter(
                                    (topic) => topic?.comment === "TOPIC"
                                  )
                                  .map(({ description }) => (
                                    <div
                                      key={description}
                                      className="overview-second-col-card-footer-topics"
                                    >
                                      <img
                                        width={30}
                                        height={30}
                                        src={makeImageSrcByName(description)}
                                        // onError={handleImgError}
                                        className="filter-icon"
                                      />
                                      <p className="overview-second-col-card-text fs-12">
                                        {description || "---"}
                                      </p>
                                    </div>
                                  ))}
                              </Col>
                              <Col>
                                <p className="overview-second-col-card-subtitle fs-14">
                                  {t("affectedBusinessUnits")}
                                </p>
                                {news_topic
                                  ?.filter(
                                    (topic) =>
                                      topic?.comment === "BUSINESS UNIT"
                                  )
                                  .map(({ description }) => (
                                    <div
                                      key={description}
                                      className="overview-second-col-card-footer-topics"
                                    >
                                      <img
                                        width={30}
                                        height={30}
                                        src={makeImageSrcByName(description)}
                                        className="filter-icon"
                                        // onError={handleImgError}
                                      />
                                      <p className="overview-second-col-card-text fs-12">
                                        {description || "---"}
                                      </p>
                                    </div>
                                  ))}
                              </Col>
                            </Row>
                            {(news_summary.length < 900 ||
                              itemVisibility[id] === true) && (
                              <Row>
                                <Col>
                                  <p className="overview-second-col-card-subtitle fs-14">
                                    {t("topics")}
                                  </p>
                                  {news_topic
                                    ?.filter(
                                      (topic) => topic?.comment === "TOPIC"
                                    )
                                    .map(({ description }) => (
                                      <div
                                        key={description}
                                        className="overview-second-col-card-footer-topics"
                                      >
                                        <img
                                          width={30}
                                          height={30}
                                          src={makeImageSrcByName(description)}
                                          onError={handleImgError}
                                          className="filter-icon"
                                        />
                                        <p className="overview-second-col-card-text fs-12">
                                          {description || "---"}
                                        </p>
                                      </div>
                                    ))}
                                </Col>
                                <Col>
                                  <p className="overview-second-col-card-subtitle fs-14">
                                    {t("affectedBusinessUnits")}
                                  </p>
                                  {news_topic
                                    ?.filter(
                                      (topic) =>
                                        topic?.comment === "BUSINESS UNIT"
                                    )
                                    .map(({ description }) => (
                                      <div
                                        key={description}
                                        className="overview-second-col-card-footer-topics"
                                      >
                                        <img
                                          width={30}
                                          height={30}
                                          src={makeImageSrcByName(description)}
                                          className="filter-icon"
                                          onError={handleImgError}
                                        />
                                        <p className="overview-second-col-card-text fs-12">
                                          {description || "---"}
                                        </p>
                                      </div>
                                    ))}
                                </Col>
                              </Row>
                            )}
                            {/* {news_summary.length > 900 && (
                              <div className="container-btn-show-more-less">
                                <button
                                  className="btn-show-more-less"
                                  onClick={() => toggleVisibility(id)}
                                >
                                  {itemVisibility[id]
                                    ? "Collapse"
                                    : "Show More"}
                                </button>
                              </div>
                            )} */}
                            {news_label === "curated" && (
                              <Row>
                                <Col className="news-card__bottom-label-wrapper">
                                  <div className="news-card__bottom-label">
                                    curated
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </Card.Footer>
                        </div>
                      </Card>
                    )
                  )}
                </InfiniteScroll>
              </div>
            </Col>
          </Col>
        </Row>
      </Container>

      <CustomModal
        classNameOfModal="reghub-loading-modal"
        isShown={
          filtersAreLoading ||
          filtersTypesAreLoading ||
          (regulatoryStreamAreLoading && !regulatoryStream?.length) ||
          top5PublishersAreLoading ||
          graphAggregationsAreLoading ||
          !graphAggregationsDetailsFormatted?.length
        }
        content={<Loader />}
        titleOfModal={t("loading")}
        isCentered={true}
        isBackdrop="static"
      />

      <CustomModal
        titleOfModal={t("addToList")}
        positiveButton={t("addToList")}
        negativeButton={t("cancel")}
        positiveAction={() => setSubmitOccurred(true)}
        negativeAction={() => {
          setAddToListDialogIsShown(false);
          setTile(tilesOfTypeLinks.length > 0 ? tilesOfTypeLinks[0] : {});
        }}
        setIsShown={setAddToListDialogIsShown}
        isShown={addToListDialogIsShown}
        classNameOfModal="add-to-list-modal"
        formId="add-new-topic-group-form"
        content={
          <FieldsInForm
            idOfForm="add-to-list-form"
            fields={argsForAddListDialog.fields}
            onSubmit={argsForAddListDialog.onSubmit}
            findFormErrors={argsForAddListDialog.findFormErrors}
            setSubmitOccurred={setSubmitOccurred}
            submitOccurred={submitOccurred}
            classNameForm={argsForAddListDialog.classNameForm}
            onSelectBoxChanged={argsForAddListDialog.onSelectBoxChanged}
          />
        }
        isBackdrop="static"
      />
      {failureMessage && !regulatoryStreamPaginationError && (
        <AlertMessage
          variant="danger"
          onClose={() => {
            filterMessagesRestarted();
            setFailureMessage("");
          }}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      )}
      {successMessage ? (
        <AlertMessage
          variant="success"
          onClose={() => {
            filterMessagesRestarted();
            setSuccessMessage("");
          }}
          successHeading={t("success")}
          mainMessage={successMessage}
        />
      ) : (
        <div className="display-none" />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userRights: state.userReducer.userRights,
    filtersAreLoading: state.filterReducer.filtersAreLoading,
    filtersTypesAreLoading: state.filterReducer.filtersTypesAreLoading,
    regulatoryStreamAreLoading: state.filterReducer.regulatoryStreamAreLoading,
    top5PublishersAreLoading: state.filterReducer.top5PublishersAreLoading,
    graphAggregationsAreLoading:
      state.filterReducer.graphAggregationsAreLoading,
    graphAggregations: state.filterReducer.graphAggregations,
    graphAggregationsTotalAmount:
      state.filterReducer.graphAggregationsTotalAmount,
    top5Publishers: state.filterReducer.top5Publishers,
    top5Countries: state.filterReducer.top5Countries,
    regulatoryStream: state.filterReducer.regulatoryStream,
    userToken: state.configReducer.userToken,
    graphAggregationsDetails: state.filterReducer.graphAggregationsDetails,
    hotTopics: state.filterReducer.hotTopics,
    hotBusinessUnits: state.filterReducer.hotBusinessUnits,
    regulatoryStreamPaginationError:
      state.filterReducer.regulatoryStreamPaginationError,
    regulatoryStreamLoadedWithError:
      state.filterReducer.regulatoryStreamLoadedWithError,
    loggedIn: state.userReducer.loggedIn,
    singleDocument: state.filterReducer.singleDocument,
    tiles: state.tileReducer.tiles,
    tilesOfTypeLinks: state.tileReducer.tilesOfTypeLinks,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    filterMessagesRestarted: bindActionCreators(
      filterMessagesRestarted,
      dispatch
    ),
    getTilesOfTypeLinks: bindActionCreators(getTilesOfTypeLinks, dispatch),
    addLink: bindActionCreators(addLink, dispatch),
    addDocument: bindActionCreators(addDocument, dispatch),
  };
};

SearchOverviewSmallScreen.propTypes = {
  userRights: PropTypes.shape({
    USER_RIGHT: PropTypes.string,
  }).isRequired,
  filterMessagesRestarted: PropTypes.func.isRequired,
  filterFailureMessage: PropTypes.string.isRequired,
  filterSuccessMessage: PropTypes.string.isRequired,
  filtersAreLoading: PropTypes.bool.isRequired,
  filtersTypesAreLoading: PropTypes.bool.isRequired,
  regulatoryStreamAreLoading: PropTypes.bool.isRequired,
  top5PublishersAreLoading: PropTypes.bool.isRequired,
  graphAggregationsAreLoading: PropTypes.bool.isRequired,
  graphAggregations: PropTypes.arrayOf(PropTypes.array).isRequired,
  graphAggregationsTotalAmount: PropTypes.number.isRequired,
  top5Publishers: PropTypes.shape({}).isRequired,
  top5Countries: PropTypes.shape({}).isRequired,
  regulatoryStream: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  userToken: PropTypes.string.isRequired,
  graphAggregationsDetails: PropTypes.arrayOf(PropTypes.array).isRequired,
  setEditNewsModal: PropTypes.func.isRequired,
  setSortField: PropTypes.func.isRequired,
  graphAggregationsDetailsFormatted: PropTypes.arrayOf(PropTypes.array)
    .isRequired,
  hotTopics: PropTypes.shape({}).isRequired,
  hotBusinessUnits: PropTypes.shape({}).isRequired,
  handlePagination: PropTypes.func.isRequired,
  regulatoryStreamPaginationError: PropTypes.bool.isRequired,
  regulatoryStreamLoadedWithError: PropTypes.bool.isRequired,
  showDeleteNewsModal: PropTypes.func.isRequired,
  setAddNewsModal: PropTypes.func.isRequired,
  tilesOfTypeLinks: PropTypes.arrayOf(
    PropTypes.shape({
      TILE_ID: PropTypes.number,
    })
  ).isRequired,
  addLink: PropTypes.func.isRequired,
  singleTopic: PropTypes.shape({
    TOPIC_ID: PropTypes.number,
    TOPIC_SEARCHTAGS: PropTypes.string,
  }).isRequired,
  loggedIn: PropTypes.bool.isRequired,
  tiles: PropTypes.arrayOf(
    PropTypes.shape({
      TILE_ID: PropTypes.number,
    })
  ),
};

SearchOverviewSmallScreen.defaultProps = {
  userRights: { USER_RIGHT: "" },
  filterMessagesRestarted: () => {},
  filterFailureMessage: "",
  filterSuccessMessage: "",
  filtersAreLoading: false,
  filtersTypesAreLoading: false,
  regulatoryStreamAreLoading: false,
  top5PublishersAreLoading: false,
  graphAggregationsAreLoading: false,
  filters: [],
  publicationTypesDataSet: [],
  publisherTypesDataSet: [],
  countriesDataSet: [],
  setCountries: () => {},
  setPublicationTypes: () => {},
  setPublisherTypes: () => {},
  countries: [],
  publicationTypes: [],
  publisherTypes: [],
  setFromDate: () => {},
  setToDate: () => {},
  setFreeText: () => {},
  preparationOfDataBeforeOperation: () => {},
  setRaiseSaveFilterModal: () => {},
  freeText: "",
  multiFilterRadioButtonsValue: "",
  setMultiFilterRadioButtonsValue: () => {},
  applyFilter: () => {},
  resetParams: () => {},
  fromDate: new Date(),
  toDate: new Date(),
  setRaiseManageFiltersModal: () => {},
  changeRadioButtonValue: 0,
  setChangeRadioButtonValue: () => {},
  graphAggregations: [],
  graphAggregationsTotalAmount: 0,
  top5Publishers: {},
  top5Countries: {},
  regulatoryStream: [],
  userToken: "",
  graphAggregationsDetails: [],
  setEditNewsModal: () => {},
  setSortField: () => {},
  graphAggregationsDetailsFormatted: [],
  hotTopics: {},
  hotBusinessUnits: {},
  handlePagination: () => {},
  regulatoryStreamPaginationError: false,
  regulatoryStreamLoadedWithError: false,
  showDeleteNewsModal: () => {},
  setAddNewsModal: () => {},
  getTilesOfTypeLinks: () => {},
  tilesOfTypeLinksAreLoading: false,
  tilesOfTypeLinks: [],
  addDocument: () => {},
  addLink: () => {},
  singleTopic: {},
  loggedIn: false,
  tiles: [],
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchOverviewSmallScreen);
